import { SxProps } from '@mui/material'

import theme from '../../styles/themes/default.theme'
import type { AvatarGradient } from './Avatar.types'

const GRADIENT_PRESETS = [
  { from: '#7C3AED', to: '#339FFF' },
  { from: '#F59E0B', to: '#EF4444' },
  { from: '#10B981', to: '#3B82F6' },
  { from: '#EC4899', to: '#8B5CF6' },
  { from: '#3B82F6', to: '#06B6D4' },
  { from: '#F59E0B', to: '#10B981' }
]

export const resolveGradient = (
  gradient: AvatarGradient | undefined,
  initials: string
): { from: string; to: string } | undefined => {
  if (!gradient) return undefined

  if (gradient === true) {
    const hash = initials.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)

    return GRADIENT_PRESETS[hash % GRADIENT_PRESETS.length]
  }

  return gradient
}

const styles = {
  container: (size: number, isName: boolean, noRightMargin?: boolean, gradient?: { from: string; to: string }) =>
    ({
      height: size,
      width: size,
      marginRight: noRightMargin ? 0 : isName ? theme.spacing(2) : 0,
      fontSize: size / 2,
      ...(gradient != null && {
        background: `linear-gradient(135deg, ${gradient.from} 0%, ${gradient.to} 100%)`
      })
    }) as SxProps,

  personIcon: (size: number) =>
    ({
      fontSize: size / 1.5
    }) as SxProps
}

export default styles
